import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
export const AddressTestingStyles = makeStyles((theme: Theme) =>
  createStyles({
    formContainer: {
      width: "100%",
      paddingBottom: "28px",
      position: "relative",
    },
    securityNotice: {
      marginBottom: theme.spacing(2),
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "19px",
    },
    modalTitle: {
      fontSize: "23px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "28px ",
      letterSpacing: " -0.46px",
    },
    currencyIcon: { height: "20px", width: "20px" },
    memoContainer: {
      padding: "24px 28px",
      alignItems: "flex-start",
      gap: "28px",
    },
    memoBox: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    memoTitle: { marginBottom: "16px" },
    memoBoxContainer: {
      border: "1px solid #000000",
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      overFlow: "scroll",
    },
    securityTitle: {
      fontSize: "23px",
      paddingBottom: theme.spacing(2),
    },
    coinsMenu: { height: "40px" },
    titleContainer: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      width: "100%",
      paddingRight: "28px",
      paddingLeft: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: "60px",
    },
    titleContainerDesktop: { borderRadius: "10px 10px 0px 0px " },
    mainContainerDesktop: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      height: "100%",
      alignItems: "center",
      padding: "24px 28px !important",
      flexGrow: 1,
    },
    mainContainerMobile: {
      height: "100%",
      alignItems: "center",
      padding: "22px",
      flexGrow: 1,
      overflow: "auto",
    },
    noAddrressTitle: { fontSize: "23px", fontWeight: 700 },
    noAddrressError: { fontSize: "19px" },
    coinLogo: { marginRight: "10px" },
    verifiedIcon: { color: "#0BEC9F" },
    closeIcon: { cursor: "pointer" },
    nextBtn: {
      backgroundColor: theme.palette.secondary.main,
      width: "100%",
      marginTop: theme.spacing(3),
      fontSize: "18px",
      height: "48px",
      textTransform: "capitalize",
      color: "#fff",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
    formHelperText: {
      marginLeft: "0px",
      bottom: 20,
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    verificationHelperText: {
      marginLeft: "0px",
      bottom: 20,
      display: "flex",
      alignItems: "center",
      gap: "8px",
      color: theme.palette.secondary.main,
    },
    resend2facode: {
      fontWeight: "bold",
      color: theme.palette.secondary.main,
      marginLeft: "5px",
    },
    helperTextLink: {
      color: theme.palette.secondary.main,
      textDecorationColor: theme.palette.secondary.main,
      marginBottom: "2px", // aligns link with other text
    },
    successLabel: {
      fontSize: "14px",
      color: theme.palette.text.secondary,
    },
    successValue: {
      fontSize: "16px",
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
    successGroup: {
      margin: theme.spacing(2, 0),
      textAlign: "left",
      width: "100%",
    },
    successContainer: {
      display: "flex",
      flexDirection: "column",
      width: "auto",
    },
    tooltip: {
      backgroundColor: "rgba(0, 32, 53, 0.8)",
      color: "#fff",
      cursor: "pointer",
    },
    dashedButton: {
      border: "1px solid",
      borderRadius: "10px",
      textTransform: "capitalize",
      color: theme.palette.text.secondary,
    },
    stepHeader: {
      fontSize: "16px",
      fontWeight: 600,
      color: theme.palette.secondary.main,
    },
    secondStepHeader: {
      fontSize: "16px",
      fontWeight: 600,
      marginTop: "28px",
      color: theme.palette.secondary.main,
    },
    explainerText: {
      fontSize: "14px",
      lineHeight: "17px",
      paddingBottom: "12px",
    },
    nextBtnDisabled: {
      backgroundColor: "#D1D4D6",
      color: "#BDC2C5",
      textTransform: "capitalize",
      fontWeight: 600,
    },
    disabled: { opacity: 0.4 },
    formLabels: {
      marginBottom: "12px",
      fontSize: "14px",
      color: theme.palette.text.secondary,
    },
    errorIcon: { color: theme.palette.error.main, fontSize: "15px" },
    errorIconInputBox: { color: theme.palette.error.main },
    warningIcon: {
      color: theme.palette.primary.main,
      fontSize: "15px",
    },
    btnContainer: {
      width: "100%",
      display: "flex",
      justifyContent: "space-around",
      gap: "10px",
    },
    amountInput: {
      height: "43px",
      position: "relative",
      minWidth: 200,
      backgroundColor: "#F8F9F9",
      "& .MuiFilledInput-root": {
        backgroundColor: "transparent",
      },
      "& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after": {
        borderBottom: "none",
      },
    },
    inputWrapper: {
      display: "flex",
      alignItems: "center",
      border: "1px solid",
      borderRadius: "8px",
      padding: "1px",
      justifyContent: "space-between",
      borderColor: theme.palette.text.secondary,
      "&:focus-within": {
        borderColor: theme.palette.primary.main,
        backgroundColor: "white",
        border: "1px solid",
      },
    },

    inputContainers: {
      height: "43px",
      position: "relative",
      minWidth: 200,
      "& .MuiOutlinedInput-input": {
        padding: "10.5px 14px",
      },
    },
    inputFilledContainers: {
      backgroundColor: "#fff",
      flex: 1,
      "& .MuiFilledInput-input": {
        textAlign: "left",
        backgroundColor: "#fff",
        paddingTop: "10px",
        lineHeight: "normal",
        paddingBottom: "10px",
      },
      "&.Mui-focused .MuiFilledInput-input": {
        backgroundColor: "#fff",
      },
      "&.Mui-hover .MuiFilledInput-input": {
        backgroundColor: "#fff",
      },
    },
    inputWithError: {
      borderColor: theme.palette.secondary.main,
    },
    autocompleteInput: {
      "& .MuiInputBase-input.MuiOutlinedInput-input": {
        height: "4px",
        padding: "10.5px 14px",
      },
    },
  }),
);
